import * as screens from '@core/layouts/components/menu/screens';
import Icon from '../../utility/icomoon';
import paths from '../../views/screens/MonitoringCenter/paths';
import permissions from '../../views/screens/MonitoringCenter/permissions';

export default [
  {
    id: 'monitoringCenterConsoleReport',
    title: 'monitoringCenter.consoleReport.consoleReport',
    icon: <Icon size={20} icon="noun_report_556224" />,
    permissions: [permissions.listReportsConsole],
    iconName: 'noun_report_556224',
    navLink: paths.consoleReportMonitoringCenter,
    screenId: screens.MONITORING_CENTER_CONSOLE_REPORT
  }
];
